var login = {
  translation: {
    common: {
      accept: 'Accepter',
      alreadyUser: 'Allerede bruger?',
      and: 'og',
      backToLogin: 'Tilbage til login-side',
      continueWith: 'Fortsæt med {{provider}}',
      createAccount: 'Opret en konto',
      createYourAccount: 'Opret din konto',
      emailOrUsername: 'E-mail eller brugernavn',
      login: 'Log ind',
      logIn: 'Log ind',
      logInToBoards: 'Log ind',
      newToBoards: 'Ny i Viki Teams?',
      pageNotFound_title: 'Siden blev ikke fundet',
      password: 'Adgangskode',
      privacyPolicy: 'Privatlivspolitik',
      register: 'Registrer',
      registerWithGoogle: 'Registrer med Google',
      termsOfService: 'Vilkår for brug',
      togglePasswordVisibility: 'Vis/skjul adgangskode',
    },
  },
};

export { login as default };
